import {
  AfterViewInit,
  ComponentFactoryResolver,
  Directive,
  Input,
  OnChanges,
  OnInit,
  Renderer2,
  ViewContainerRef
} from '@angular/core';
import { ElementRef, SimpleChanges } from '@angular/core';
import { MatLegacyProgressSpinner as MatProgressSpinner } from '@angular/material/legacy-progress-spinner';

@Directive({
  selector: 'button[appShowSpinner]'
})
export class AsyncButtonDirective implements OnInit, OnChanges, AfterViewInit {
  @Input('appShowSpinner') showSpinner: boolean;
  @Input()
  buttonText: string;
  @Input('disabled') disabled: boolean;
  spinner: MatProgressSpinner;
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private viewContainerRef: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver
  ) {}
  ngOnInit() {
    // Create the spinner
    const factory = this.componentFactoryResolver.resolveComponentFactory(MatProgressSpinner);
    const componentRef = this.viewContainerRef.createComponent(factory);
    this.spinner = componentRef.instance;
    // Configure the spinner
    this.spinner.strokeWidth = 3;
    this.spinner.diameter = 24;
    this.spinner.mode = 'indeterminate';
    // Hide the spinner
    this.renderer.setStyle(this.spinner._elementRef.nativeElement, 'display', 'none');
    // Apply new styles to the button content's container
    const span = this.el.nativeElement.querySelector('.mat-button-wrapper') as HTMLSpanElement;
    this.renderer.setStyle(span, 'display', 'flex');
    this.renderer.setStyle(span, 'align-items', 'center');
    this.renderer.setStyle(span, 'justify-content', 'center');
    this.renderer.addClass(this.spinner._elementRef.nativeElement, 'mat-alt');
  }
  ngAfterViewInit() {
    const span = this.el.nativeElement.querySelector('.mat-button-wrapper') as HTMLSpanElement;
    span.innerText = this.buttonText;
    // Set the button to maintain the same dimensions, even once we put the spinner inside.
    this.el.nativeElement.style.width = `${(this.el.nativeElement as HTMLElement).offsetWidth}px`;
    this.el.nativeElement.style.height = `${(this.el.nativeElement as HTMLElement).offsetHeight}px`;
    this.el.nativeElement.disabled = this.disabled;
  }
  ngOnChanges(changes: SimpleChanges) {
    if (typeof changes.showSpinner === 'object' && !changes.showSpinner.isFirstChange()) {
      if (changes.showSpinner.currentValue === true) {
        // Clear the button's text
        const span = this.el.nativeElement.querySelector('.mat-button-wrapper') as HTMLSpanElement;
        span.innerText = '';
        // Append the spinner
        this.renderer.appendChild(this.el.nativeElement.firstChild, this.spinner._elementRef.nativeElement);
        // Show the spinner
        this.renderer.setStyle(this.spinner._elementRef.nativeElement, 'display', 'inherit');
      }
      if (changes.showSpinner.currentValue === false) {
        // Hide the spinner
        this.renderer.setStyle(this.spinner._elementRef.nativeElement, 'display', 'none');
        // Remove the spinner
        this.renderer.removeChild(this.el.nativeElement.firstChild, this.spinner._elementRef.nativeElement);
        const span = this.el.nativeElement.querySelector('.mat-button-wrapper') as HTMLSpanElement;
        span.innerText = this.buttonText;
      }
      this.el.nativeElement.disabled = this.disabled || changes.showSpinner.currentValue;
    }
  }
}
